import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CookieBanner } from "./components/cookie/CookieBanner";
import { Footer } from "./components/layout/Footer";
import Index from "./pages/Index";
import Dashboard from "./pages/admin/Dashboard";
import Register from "./pages/auth/Register";
import OwnerLogin from "./pages/auth/OwnerLogin";
import AdminLogin from "./pages/auth/AdminLogin";
import BusinessTypes from "./pages/admin/BusinessTypes";
import Companies from "./pages/admin/Companies";
import InterfaceModel from "./pages/admin/InterfaceModel";
import BusinessInterface from "./pages/business/BusinessInterface";
import OwnerDashboard from "./pages/owner/Dashboard";
import Stock from "./pages/owner/Stock";
import History from "./pages/owner/History";
import Users from "./pages/admin/Users";
import Counting from "./pages/owner/Counting";
import Settings from "./pages/owner/Settings";
import Returns from "./pages/owner/Returns";
import Budget from "./pages/owner/Budget";
import OwnerRegister from "./pages/auth/OwnerRegister";
import Poultry from "./pages/owner/Poultry";
import EggProduction from "./pages/owner/EggProduction";
import Suppliers from "./pages/owner/Suppliers";
import Privacy from "./pages/legal/Privacy";
import Terms from "./pages/legal/Terms";
import Cookies from "./pages/legal/Cookies";
import Tutorials from "./pages/admin/Tutorials";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <CookieBanner />
      <BrowserRouter>
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/admin" element={<Dashboard />} />
              <Route path="/admin/users" element={<Users />} />
              <Route path="/admin/business-types" element={<BusinessTypes />} />
              <Route path="/admin/business-types/:id/interface" element={<InterfaceModel />} />
              <Route path="/admin/companies" element={<Companies />} />
              <Route path="/admin/tutorials" element={<Tutorials />} />
              <Route path="/register" element={<Register />} />
              <Route path="/register-owner" element={<OwnerRegister />} />
              <Route path="/login-owner" element={<OwnerLogin />} />
              <Route path="/login-admin" element={<AdminLogin />} />
              <Route path="/owner" element={<OwnerDashboard />} />
              <Route path="/owner/products" element={<OwnerDashboard />} />
              <Route path="/owner/stock" element={<Stock />} />
              <Route path="/owner/poultry" element={<Poultry />} />
              <Route path="/owner/egg-production" element={<EggProduction />} />
              <Route path="/owner/history" element={<History />} />
              <Route path="/owner/counting" element={<Counting />} />
              <Route path="/owner/settings" element={<Settings />} />
              <Route path="/owner/returns" element={<Returns />} />
              <Route path="/owner/budget" element={<Budget />} />
              <Route path="/owner/suppliers" element={<Suppliers />} />
              <Route path="/business/:businessTypeId" element={<BusinessInterface />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cookies" element={<Cookies />} />
              {/* Add a catch-all route that redirects to the home page */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;